export default "__VITE_ASSET__Cqprsr7k__"